"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Event_1 = __importDefault(require("../Event"));
const index_1 = require("../index");
const Participant_1 = require("../../models/Participant");
/**
 * The InvitationReceived model gathers information about the received conference invitations, such as the conference [alias](#conferencealias), [ID](#conferenceid), [conference access token](#conferencetoken), and information about the [participant](#participant) who sent the invitation.
 */
class InvitationReceived extends Event_1.default {
    /** @ignore */
    constructor() {
        super(index_1.EventType.InvitationReceived);
    }
    /** @ignore */
    static fromData(data) {
        const res = new InvitationReceived();
        res.conferenceId = data.conferenceId;
        res.conferenceAlias = data.confAlias;
        res.conferenceToken = data.confToken;
        res.participant = new Participant_1.Participant(data.inviter.userId, 'ON_AIR');
        res.participant.info.name = data.inviter.nickName;
        res.participant.info.externalId = data.inviter.externalId;
        res.participant.info.avatarUrl = data.inviter.externalAvatarUrl;
        return res;
    }
}
exports.default = InvitationReceived;
